import { ErrorHandler, Injectable } from '@angular/core';

import { ApplicationError } from '../../error-handler/error-handler.service';
import { JsonElementParser } from '../utilities/json-element-parser.utility';
import { ApiConfigurationDataService } from './api-configuration-data.service';

@Injectable()
export class ApiConfigParserService {

    private readonly configMap: Map<string, string>;

    constructor(
        private readonly apiConfigurationDataService: ApiConfigurationDataService,
        private readonly globalErrorHandler: ErrorHandler
    ) {
        this.configMap = new Map(Object.entries(this.apiConfigurationDataService.shellAndConfigData));
    }

    public parse<T>(
        configElementId: string,
        containsEncodedStrings = false
    ): T {
        try {
            if (this.configMap.has(configElementId)) {
                if (containsEncodedStrings) {
                    const decodedText = JsonElementParser.decodeJsonString(this.configMap.get(configElementId));
                    return JSON.parse(decodedText) as T;
                } else {
                    return JSON.parse(this.configMap.get(configElementId)) as T;
                }
            } else {
                return JsonElementParser.parseJsonElementWithId(configElementId) as T;
            }
        } catch (ex) {
            const wrappedError = new ApplicationError(`Failure to parse ${configElementId} from ShellConfig response`, ex);
            this.globalErrorHandler.handleError(wrappedError);
        }
    }
}
